import React, { FC } from "react";
import { Grid, Typography } from "@mui/material";
import { COLORS } from "../styles/colors";
import Logo from "./svg/Logo";
import useAuthentication from "../hooks/useAuthentication";
import useIsPortal from "../hooks/useIsPortal";
import useAuthorization from "../hooks/useAuthorization";

interface HomeHeaderProps {
  vorname: string;
  nachname: string;
  admin: boolean;
  rolle?: string;
}

const HomeHeader: FC<HomeHeaderProps> = ({
  vorname,
  nachname,
  admin,
  rolle,
}) => {
  return (
    <Grid
      container
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      <Grid item>
        <Logo fill={COLORS.tuv_r_blue} height={50} />
      </Grid>
      <Grid item>
        <Typography variant="h5" style={{ fontWeight: "bold" }}>
          {vorname} {nachname}
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant="h6" style={{ fontWeight: "light" }}>
          {admin ? "Administrator" : rolle ? rolle : "Nutzer"}
        </Typography>
      </Grid>
    </Grid>
  );
};

export const HomeHeaderWebMap: FC<Omit<HomeHeaderProps, "rolle">> = ({
  vorname,
  nachname,
  admin,
}) => {
  const { rolle } = useAuthorization();
  return (
    <HomeHeader
      vorname={vorname}
      nachname={nachname}
      admin={admin}
      rolle={rolle}
    />
  );
};

export const HomeHeaderWithContext = () => {
  const { user } = useAuthentication();
  const { isPortal } = useIsPortal();

  if (!user) {
    return <></>;
  }

  if (isPortal)
    return (
      <HomeHeader
        vorname={user.vorname}
        nachname={user.nachname}
        admin={user.admin}
      />
    );

  return (
    <HomeHeaderWebMap
      vorname={user.vorname}
      nachname={user.nachname}
      admin={user.admin}
    />
  );
};

export default HomeHeader;
